export const endpoint = {
    getLogin: "/signIn",
    changePassword: "/changePassword",
    resetPassword: '/resetPassword',
    verifyOtp:'/otpVerify',
    adminForgotPassword:"/forgotPassword",
    getAdminProfile:"/getProfile",
    addCompany: "/addCompany",
    listOfCompany: "/listOfCompany",
    editCompany: "/editCompany",
    addVehicle: "/addVehicle",
    listOfVehicle: "/listOfVehicle",
    updateStatusVehicle: "/updateStatusVehicle",
    editVehicle: "/editVehicle",
    listOfAllCompany: "/listOfAllCompany",
    listOfCompanyLocation: "/listOfCompanyLocation",
    listOfAlllocation: "/listOfAlllocation",
    addRoute: "/addRoute",
    listOfRoute: "/listOfRoute",
    viewRoute: "/viewRoute",
    editRoute: "/editRoute",
    updateStatusRoute: "/updateStatusRoute",
    addLocation: "/addLocation",
    editLocation: "/editLocation",
    listOflocation: "/listOflocation",
    updateStatusLocation: "/updateStatusLocation",
    addFuelPump: "/addFuelPump",
    listOfFuelPump: "/listOfFuelPump",
    listOfFuelPumpCompany: "/listOfFuelPumpCompany",
    viewFuelPump: "/viewFuelPump",
    editFuelPump: "/editFuelPump",
    updateStatusFuelPump: "/updateStatusFuelPump",
    getAward: "/getAward",
    updateAward: "/updateAward",


    getAllusers:'/getAllusers',
    getUserDetails:"/getUserDetails",
    deleteUser: "/deleteUser",
    updateStatus:'/updateStatus',
    getEventsCreatedByUser:'/getEventsCreatedByUser',
    getCms:"/getCms",
    updateCms:'/updateCms',
    deleteUser:'/deleteUser',
    getEvent:'/getEvent',
    getEventByPartyId:'/getEventParticipantsByEventId',
    getAllEvents:'/getAllEvents',
    getEventById:'/getEventById',
    getSubAdminList:'/getSubAdminList',
    listOfSubAdmin:'/listOfSubAdmin',
    logout:'/logout',
    moduleList:'/getModuleList',
    listOfModule:'/listOfModule',
    addSubAdmin:'/addSubAdmin',
    createRole:'/createRole',
    getRoleList:'/getRoleModuleWiseList',
    deleterole:'/deleteRole',
    subAdminRole:'/getRoleList',
    createSubAdmin:'/createSubAdminRole',
    getDashboarddata:'/dashboard',
    SubAdminView:'/viewSubAdmin',
    updateSubAdmin:'/updateSubAdmin',
    editSubAdmin:'/editSubAdmin',
    updateStatusSubAdmin:'/updateStatusSubAdmin',
    deleteSubAdmin:'/deleteSubAdmin',
    blockSubAdmin:'/blockUnblockSubAdmin',
    getRoleByid:'/getRoleModuleById',
    editRole:'/editRole',
    addAccountant: "/addAccountant",
    listOfAccountant: "/listOfAccountant",
    viewAccountant: "/viewAccountant",
    listOfAssignedTrip: "/listOfAssignedTrip",
    viewTripDetails: "/viewTripDetails",
    listOfExpence: "/listOfExpence",
    editAccountant: "/editAccountant",
    updateStatusAccountant: "/updateStatusAccountant",
    listOfAllFuelPump: "/listOfAllFuelPump",
    listOfFuelSettlement: "/listOfFuelSettlement",
    viewFuelSettlementDetails: "/viewFuelSettlementDetails",
    exportFuelSettlementCsv: "/exportFuelSettlementCsv",
    getFuelSettlementCsvLog: "/getFuelSettlementCsvLog",
    submitFuelSettlement: "/submitFuelSettlement",
    editFuelSettlement: "/editFuelSettlement",
    listOfFuelPumpManagement: "/listOfFuel",
    viewFuelHistory: "/viewFuelHistory",
    listOfFuelHistory: "/listOfFuelHistory",
    addFuelOperator: "/addFuelOperator",
    listOfFuelOperator: "/listOfFuelOperator",
    updateStatusFuelOperator: "/updateStatusFuelOperator",
    editFuelOperator: "/editFuelOperator",
    viewFuelOperator: "/viewFuelOperator",
    listOfDriver: "/listOfDriver",
    exportListOfDriver: "/exportListOfDriver",
    listOfDriverSalary: "/listOfDriverSalary",
    updateStatusDriver: "/updateStatusDriver",
    viewDriver: "/viewDriver",
    listOfTripHistory: "/tripHistoryList",
    listOfTripHistoryByDriver:"/listOfTripHistory",
    getTripCancelTypeList: "/getTripCancelTypeList",
    cancelTrip: "/tripCancel",
    editDriver: "/editDriver",
    /** Optional: POST body { driver_id, country_code, mobile_number } — if API returns `data.otp` it shows in the edit-driver OTP modal (dev/sandbox). */
    sendDriverMobileOtp: "/sendOtp",
    listChangeRequestsForAdmin: "/listChangeRequestsForAdmin",
    listFuelFormChangeRequests: "/listFuelFormChangeRequests",
    viewChangeRequest: "/viewChangeRequest",
    viewFuelFormChangeRequest: "/viewFuelFormChangeRequest",
    approveChangeRequest: "/approveChangeRequest",
    rejectChangeRequest: "/rejectChangeRequest",
    listOfLedgerType: "/listOfLedgerType",
    listOfDriverLedger: "/listOfDriverLedger",
    getDriverLedgerCSV: "/getDriverLedgerCSV",
    getDriverLedgerCsvLog: "/getDriverLedgerCsvLog",
    paymentHistory: "/paymentHistory",
    getPaymentHistoryCSV: "/getPaymentHistoryCSV",
    getPaymentCsvLog: "/getPaymentCsvLog",
    getReportCsvLog: "/getReportCsvLog",
    createExpenseReportCsv: "/createExpenseReportCsv",
    createDPRCsv: "/createDPRCsv",
    createDriverReportCsv: "/createDriverReportCsv",
    createTripCsv: "/createTripCsv",
    createDriverSalaryReport: "/createDriverSalaryReport",
};